import script from "./PopperActionAgentGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopperActionAgentGroup.vue?vue&type=script&setup=true&lang=ts"

import "./PopperActionAgentGroup.vue?vue&type=style&index=0&id=5f9522b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9522b0"]])

export default __exports__